import { enhancedRequest } from "../utils/request.js";

// 查询学段
// GET /api/v1/user/precise/select/stage
const selectStageList = () =>
  enhancedRequest({
    url: "/api/v1/user/precise/select/stage",
    method: "get",
  });

// 初始化测评
// GET /api/v1/user/precise/init?stageId=1
const initPreciseExam = (stageId) =>
  enhancedRequest({
    url: "/api/v1/user/precise/init",
    method: "get",
    data: {
      stageId,
    },
  });

// 提交答题记录
// POST /api/v1/user/precise/submitAnswer
const submitPreciseAnswer = (data = {}) =>
  enhancedRequest({
    url: "/api/v1/user/precise/submitAnswer",
    method: "post",
    data,
  });

// 查询精准测评报告
// GET /api/v1/user/precise/getPreciseReport
const getPreciseReport = () =>
  enhancedRequest({
    url: "/api/v1/user/precise/getPreciseReport",
    method: "get",
    acceptBizCodes: [0],
  });

// 精准测评：老师评价（AI 分析）内容保存
// POST /api/v1/user/precise/ai/analysis/report
const savePreciseAiAnalysisReport = ({ analysis, reportId } = {}) =>
  enhancedRequest({
    url: "/api/v1/user/precise/ai/analysis/report",
    method: "post",
    data: {
      analysis: typeof analysis === "string" ? analysis : String(analysis ?? ""),
      ...(reportId != null && String(reportId).trim() !== ""
        ? { reportId: String(reportId).trim() }
        : {}),
    },
  });

export {
  selectStageList,
  initPreciseExam,
  submitPreciseAnswer,
  getPreciseReport,
  savePreciseAiAnalysisReport,
};

